import { useQuery } from "react-query";
import { getDataConnection } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useDataConnection = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetDataConnection",
    getDataConnection,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
